import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MockCdrRequest } from './cdr-dump.component';
import { FileDownloadService } from '../shared/services/file-download.service';

@Injectable()
export class CdrDumpResource {
  private http = inject(HttpClient);
  private fileDownloadService = inject(FileDownloadService);

  generateCdrs(request: MockCdrRequest): Observable<void> {
    return this.fileDownloadService.downloadFile(
      `/services/cisco/reporting/cucm-cdrs/imports/dump-files/dummy-device-utilization-cdrs`,
      'post',
      request,
    );
  }
}
